var $1729b68fc5d3f126$exports = {};
$1729b68fc5d3f126$exports = {
    "time": `Time`,
    "startTime": `Start time`,
    "endTime": `End time`
};


export {$1729b68fc5d3f126$exports as default};
//# sourceMappingURL=en-US.module.js.map
